// extracted by mini-css-extract-plugin
export var actionText = "_p3-4";
export var container = "_p3-0";
export var leftSection = "_p3-1";
export var rightSection = "_p3-2";
export var settingsButton = "_p3-6";
export var settingsIcon = "_p3-7";
export var shortcut = "_p3-5";
export var shortcutGroup = "_p3-3";